import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class BasketService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  currentBasket;
  currentItem;
  purchase;

  constructor(
    private http: HttpClient
  ) { }

  async createBasket(selectedLocation) {
    const company = selectedLocation;
    this.currentBasket = await company.$post('baskets', { company_id: company.id });
    return this.currentBasket;
  }

  async getCurrentBasket(selectedLocation) {
    const company = selectedLocation;
    console.log("localStorage",localStorage.getItem("auth_token"),sessionStorage.getItem("auth_token"))
    const baseBasketResource = await company.$get('baskets', { company_id: company.id });
    const baskets = await baseBasketResource.$get('baskets');
    this.currentBasket = baskets[baskets.length - 1];
    return baskets[baskets.length - 1];
  }

  async deleteAllBaskets(selectedLocation) {
    const company = selectedLocation;
    if (!(await company.$has('baskets'))) {
      return null;
    }

    let baskets = await this.checkForExistingBaskets(company);
    console.log("baskets", baskets)
    if (baskets.length >= 1) {
      for (const basket of baskets) {
        try {
          await basket.$del('self', {})

        } catch (err) {
          console.log("err", err)
        }
      }
      console.log(company)
      await company.$del("baskets", { company_id: company.id })
      const b = await company.$getBaskets("baskets", { company_id: company.id })
      const bs = await b.$get('baskets')
      console.log(bs)
    }
    // console.log(await company.$has('baskets'))
  }


  async checkForExistingBaskets(selectedLocation) {
    const company = selectedLocation;
    if (company.$has('baskets')) {
      const baseBasketResource = await company.$get('baskets', { company_id: company.id });
      const baskets = await baseBasketResource.$get('baskets');
      return baskets;
    }
  }

  async addItem(selectedLocation, service_id, duration, start, questions) {
    const company = selectedLocation;
    if (company.$has('baskets')) {

      try {
        this.currentItem = await this.currentBasket.$post('service_items', {}, {
          service_id,
          duration,
          start,
          company_id: company.id,
          basket_id: this.currentBasket.id,
          questions
        });
        return this.currentItem;
      } catch (error) {
        const nr: any = window['newrelic'];
        if (nr) {
          nr.addPageAction('WRWAError', {
            client: 'wrwa',
            host: AppConfig.settings.apiServer?.api_url ?? '',
            errorMessage: this.serializeError(error),
            errorStatus: this.extractErrorStatus(error),
            errorUrl: this.extractErrorUrl(error),
            errorType: 'SERVICE_ITEM',
            operation: 'ADD_ITEM',
            currentItemId: this.currentItem?.id ?? null,
            currentBasketId: this.currentBasket?.id ?? null,
            questionsLength: Array.isArray(questions) ? questions.length : 0,
          });
        }
        return 'failed';
      }
    }
  }

  async updateItem(selectedLocation, service_id, duration, start, questions) {
    console.log({ params: { service_items: this.currentItem.id } })
    const company = selectedLocation;
    const body = {
      service_id,
      duration,
      start,
      company_id: company.id,
      basket_id: this.currentBasket.id,
      questions: questions
    };

    let lastError: any = null;
    let didRetry = false;

    // AH-375: single retry on transport-level failure (no HTTP response received).
    // PUT is idempotent so a retry is safe. We do NOT retry on 4xx/5xx responses —
    // those are real server-side rejections and should fail fast.
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const res = await this.currentItem.$put('self', {}, body);
        if (attempt > 0) {
          const nr: any = window['newrelic'];
          if (nr) {
            nr.addPageAction('AH375UpdateItemRetrySucceeded', {
              client: 'wrwa',
              currentItemId: this.currentItem?.id ?? null,
              currentBasketId: this.currentBasket?.id ?? null,
              questionsLength: Array.isArray(questions) ? questions.length : 0,
            });
          }
        }
        return res;
      } catch (error) {
        lastError = error;
        const errAny = error as any;
        const isTransportFailure = !errAny?.response && this.extractErrorStatus(error) == null;
        if (attempt === 0 && isTransportFailure) {
          didRetry = true;
          const nr: any = window['newrelic'];
          if (nr) {
            nr.addPageAction('AH375UpdateItemRetryAttempt', {
              client: 'wrwa',
              currentItemId: this.currentItem?.id ?? null,
              currentBasketId: this.currentBasket?.id ?? null,
              questionsLength: Array.isArray(questions) ? questions.length : 0,
            });
          }
          await new Promise((r) => setTimeout(r, 500));
          continue;
        }
        break;
      }
    }

    console.log(lastError);
    const nr: any = window['newrelic'];
    if (nr) {
      nr.addPageAction('WRWAError', {
        client: 'wrwa',
        host: AppConfig.settings.apiServer?.api_url ?? '',
        errorMessage: this.serializeError(lastError),
        errorStatus: this.extractErrorStatus(lastError),
        errorUrl: this.extractErrorUrl(lastError),
        errorType: 'SERVICE_ITEM',
        operation: 'UPDATE_ITEM',
        currentItemId: this.currentItem?.id ?? null,
        currentBasketId: this.currentBasket?.id ?? null,
        questionsLength: Array.isArray(questions) ? questions.length : 0,
        retryAttempted: didRetry,
      });
    }
    return 'failed';
  }

  private serializeError(error: any): string {
    if (error == null) return '';
    try {
      const out: any = {};
      // HttpErrorResponse / Error / generic — pick up non-enumerable getters explicitly
      if (error.name) out.name = error.name;
      if (error.message) out.message = error.message;
      if (error.status !== undefined) out.status = error.status;
      if (error.statusText) out.statusText = error.statusText;
      if (error.url) out.url = error.url;
      if (error.error !== undefined) {
        out.error = typeof error.error === 'string' ? error.error : (() => {
          try { return JSON.stringify(error.error); } catch { return String(error.error); }
        })();
      }
      // bookingbug-core-js sometimes wraps a response object
      if (error.response) {
        out.responseStatus = error.response.status;
        out.responseUrl = error.response.url ?? error.response.config?.url;
        try { out.responseData = JSON.stringify(error.response.data); } catch { /* ignore */ }
      }
      // Fallback: stringify the whole thing in case anything was enumerable
      try {
        const raw = JSON.stringify(error);
        if (raw && raw !== '{}') out.raw = raw;
      } catch { /* ignore circular */ }
      // Last resort
      if (Object.keys(out).length === 0) out.toString = String(error);
      return JSON.stringify(out);
    } catch {
      return String(error);
    }
  }

  private extractErrorStatus(error: any): number | null {
    if (!error) return null;
    return error.status ?? error.response?.status ?? null;
  }

  private extractErrorUrl(error: any): string | null {
    if (!error) return null;
    return error.url ?? error.response?.url ?? error.response?.config?.url ?? null;
  }

  checkoutBasket(selectedLocation, client, notifications) {
    const company = selectedLocation;
    if (company.$has('baskets')) {

      try {
        return this.currentBasket.$post('checkout', {}, {
          client,
          basket_id: this.currentBasket.id,
          no_notifications: notifications
        }).then((res) => {
          this.purchase = res;
          return res;
        });
      } catch (error) {
        return 'failed';
      }
    }
  }

  async getPurchase() {
    return this.purchase;
  }

  async addAttachement(purchase, bookings, formData) {
    const headers: HttpHeaders = new HttpHeaders({
      'App-Id': this.core.app_id,
      // 'App-Key': this.core.app_key
    });
    const apiUrl = `${this.apiServer.api_url}/api/${this.apiServer.version}/purchases/${purchase.long_id}/bookings/${bookings[0].id}/attach`;
    const attach = await this.http.post(apiUrl, formData, { headers }).toPromise();
    return attach;
  }
}
